import React from 'react';
import MobileModal from 'v3/common/components/MobileModal';
import { useAlgoversePayment } from '../hook/useAlgoversePayment';
import { getPaymentUIConfig } from '../getPaymentUIConfig';
import { AlgoversePaymentModalProps } from '../types.type';

const AlgoversePaymentModal: React.FC<AlgoversePaymentModalProps> = ({
  orderId,
  showModal,
  setShowModal,
  selectedPlan,
}) => {
  const payment = useAlgoversePayment({ orderId, selectedPlan, showModal, setShowModal });
  const paymentUIConfig = getPaymentUIConfig({ ...payment, selectedPlan })[payment.paymentStatus];

  return (
    <MobileModal
      isOpen={showModal}
      className="algoverse-payment-modal mobile"
      renderHeaderComponent={
        <>
          <div className="modal-title">
            {paymentUIConfig.title}
            <button
              type="button"
              onClick={() => setShowModal(false)}
              className="btn-close"
              aria-label="Close"
            ></button>
          </div>
        </>
      }
      renderContentComponent={paymentUIConfig.renderBody()}
      renderFooterComponent={paymentUIConfig.renderFooter()}
    />
  );
};

export default AlgoversePaymentModal;
